import { render } from "./OfferChongya.vue?vue&type=template&id=39f37f75&scoped=true"
import script from "./OfferChongya.vue?vue&type=script&lang=js"
export * from "./OfferChongya.vue?vue&type=script&lang=js"

import "./OfferChongya.vue?vue&type=style&index=0&id=39f37f75&scoped=true&lang=css"

import exportComponent from "/workspace/wum/vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39f37f75"]])

export default __exports__